module.exports = __webpack_public_path__ + "img/25.c6b9b83f.jpg";